export const getDocuments = (payload?: any) => ({
    type: "@saga/GET_DOCUMENTS",
    payload
});

